import styled from "styled-components";
import Button from "../Button";
import { zIndex } from "../../constants";

export const StatesViewToggle = styled.div`
  display: flex;
  position: absolute;
  z-index: ${zIndex.legendToggle};
  bottom: 20px;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0 12px;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;

  @media (min-width: 640px) {
    top: 18px;
    bottom: auto;
    left: 20px;
    right: auto;
    width: auto;
    padding: 0;
    justify-content: flex-start;
  }
`;

export const ToggleButton = styled(Button)`
  white-space: nowrap;
  flex: 0 1 auto;
`;

export const MapSearchAutosuggest = styled.div`
  width: 100%;
`;